import React from "react";
import "./special-route.scss";

const SpecialRoute = () => {
    return (
        <div className="special_route" id="special-route">
            <div className="special_route__inner">
                <h2 className="special_route_title">Ерекше шарттар</h2>
                <div className="special_route_body">
                    <p>
                        Курсқа қабылдау Tech Orda бағдарламасының талаптарына және KazMBS ақпараттық технологиялар мектебінің ішкі іріктеу тәртібіне сәйкес жүргізіледі. Талапкерлер қажет болған жағдайда сұхбаттасудан және бастапқы білім деңгейін анықтайтын кіріс тестінен өтеді.
                    </p>
                    <p>
                        Грант негізінде оқуға қабылданған білім алушы оқу басталғанға дейін 50 000 теңге көлемінде кепілдік жарна төлейді. Білім алушы оқу процесінен өз еркімен шығып қалған немесе оқу талаптарын орындамаған жағдайда кепілдік жарна қайтарылмайды.
                    </p>
                    <p>
                        Оқу барысында білім алушы сабақтарға тұрақты қатысуға, тапсырмаларды уақытылы орындауға және курстың қорытынды талаптарынан сәтті өтуге міндетті.
                    </p>
                    <p>
                        Күту тізіміндегі үміткерлер негізгі қабылдау аяқталғаннан кейін бос орын болған жағдайда кезек тәртібімен қарастырылады, ал жеңілдік, бөліп төлеу немесе өзге қаржылық шарттар мектептің ішкі тәртібі мен Tech Orda бағдарламасының қолданыстағы талаптарына сәйкес жеке қарастырылады.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SpecialRoute;